/**
 * getCurrYear :: () -> Number
 *
 * @return {number}
 */
export const getCurrYear = () => new Date().getFullYear();
